export class LoyaltyChart {

  /*static readonly koncentroColors: string[] =  [
    '#e0ffff',
    '#d7f4f8',
    '#cdeaf1',
    '#c3dee9',
    '#b9d4e2',
    '#afcadb',
    '#a5bfd4',
    '#9cb5cc',
    '#93abc6',
    '#89a0bf',
    '#8097b8',
    '#768cb0',
    '#6d83a9',
    '#647aa3',
    '#596f9c',
    '#506795',
    '#465e8e',
    '#3c5487',
    '#314b81',
    '#26437a',
    '#fdc500'
  ];*/

  static readonly colors: string[] =  [
    '#227FB0',
    '#2ab0c5',
    '#fbb735',
    '#eb403b',
    '#e98931',
    '#227FB0',
    '#1f5ea8',
    '#b32E37',
    '#274389',
    '#5c4399',
    '#6c2a6a',
    '#ef9855',
    '#efe555',
    '#85bffc',
    '#b87eef',
    '#47c240',
    '#ec6659',
    '#8354bf',
    '#28c582',
    '#e365cb',
    '#f2af0e',
    '#888888',
    '#333333'
  ];

  static readonly sankeyColors: string[] = [
    '#49C0B2',
    '#EAE14B',
    '#D47540',
    '#eb403b',
    '#274389',
    '#5EA380',
    '#6c2a6a',
    '#ef9855',
    '#efe555',
    '#85bffc',
    '#47c240',
    '#ec6659',
    '#28c582',
    '#e365cb',
    '#f2af0e',
  ];

  public instance: any;

  public options: any;

  constructor (type: string, uom = '') {
    this.options = {
      chart: {
        type: type,
        height: 350,
        zoomType: 'xy'
      },
      title: { text: '' },
      tooltip: {
        valueDecimals: 2,
      },
      xAxis: {
        categories: [],
        title: {
          text: ''
        },
        labels: {
          overflow: 'justify',
          format: '{value}'
        }
      },
      yAxis: {
        min: 0,
        title: {
          text: '',
          align: 'middle'
        },
        labels: {
          overflow: 'justify',
          formatter: function() {
            let valore = this.value;
            let mult = '';
            if (valore > 1000000) {
              valore = valore / 1000000;
              mult = 'M';
            }
            if (valore > 1000) {
              valore = valore/ 1000;
              mult = 'K' + mult;
            }
            mult = mult + uom;

            return valore + mult; // Highcharts.numberFormat(valore, 0);
          }
        }
      },

      legend: {
        verticalAlign: 'top'
      },

      credits: {
        text: 'Konvergence.it',
        href: 'javascript:window.open("http://www.konvergence.it/", "_blank")'
      }

    };
  }

  /**
   *
   * @returns {any}
   */
  public getOptions() {
    return this.options;
  }

  /**
   * @param num
   * @return {string[]}
   */
  /*public getColors (num: number, colors: [] = LoyaltyChart.colors): string[] {
    let numColors = colors.length ();
    if (num === 2) {
      return [colors[numColors - 2], colors[numColors - 1]];
    } else if (num < numColors) {
      let step = Math.floor (numColors / num);
      let colors = [];
      for (let i = 0; i < (num * step); i = (i + step)) {
        colors.push (colors[numColors - 1 - i]);
      }
      return colors;
    } else {
      return colors;
    }
  }*/
}


export class LoyaltySankeyChart {

  static readonly colors: string[] =  [
    '#2ab0c5',
    '#fbb735',
    '#227FB0',
    '#e98931',
    '#eb403b',
    '#1f5ea8',
    '#b32E37',
    '#274389',
    '#5c4399',
    '#6c2a6a',
  ];

  public instance: any;

  public options: any;

  constructor () {
    this.options = {
      title: { text: '' },
      series: [{
        keys: [],
        data: [],
        type: 'sankey'
      }]
    };
  }

  public cleanSeries(){
    this.options.series = [{
      keys: [],
      data: [],
      type: 'sankey'
    }];
  }

  /**
   *
   * @returns {any}
   */
  public getOptions() {
    return this.options;
  }

}



// WEBPACK FOOTER //
// ./src/app/models/loyalty-chart-config.model.ts